import { Trans } from 'react-i18next';

import { appendTestableElementAttributes, Heading, StyledFlex } from '@dreryk/react-components';

import { dashboardTranslationKeys } from '../../translations';

import { EGABINET_NEWS_COUNT, useEGabinetNews } from './NewsCard.hooks';
import { StyledNewsCard, StyledNewsLinksContainer } from './NewsCard.styled';
import { NewsCardListElement } from './NewsCardListElement';
import { NewsCardListElementLoader } from './NewsCardListElement.loader';
import { StyledCard, StyledCardUpdatedData } from './shared/Card.styled';
import { DateUpdatedText } from './shared/DateUpdatedText';

export const NewsCard = (): JSX.Element => {
   const news = useEGabinetNews();

   return (
      <StyledCard>
         <StyledNewsCard {...appendTestableElementAttributes('newsCard')}>
            <StyledFlex justifyContent='space-between'>
               <Heading bold content={dashboardTranslationKeys.cards.news} testId={'news'} type='h2' margin={'8px'} />
               <StyledCardUpdatedData>
                  <Trans
                     i18nKey={dashboardTranslationKeys.cards.dataUpdated}
                     components={{
                        date: <DateUpdatedText date={new Date(Date.now())} />,
                     }}
                  />
               </StyledCardUpdatedData>
            </StyledFlex>
            <StyledNewsLinksContainer>
               {[...Array(EGABINET_NEWS_COUNT)].map((__, index) => (
                  <NewsCardListElementLoader
                     egabinetNews={news.egabinetNews?.[index]}
                     egabinetNewsError={news.egabinetNewsError}
                     egabinetNewsLoading={news.egabinetNewsLoading}
                     // eslint-disable-next-line react/no-array-index-key
                     key={index}
                  >
                     {({ egabinetNews }) => <NewsCardListElement egabinetNews={egabinetNews} />}
                  </NewsCardListElementLoader>
               ))}
            </StyledNewsLinksContainer>
         </StyledNewsCard>
      </StyledCard>
   );
};
